import { GetHelpMenuDisplayItemsQuery } from 'generated/graphql';

export function setNotifyItemReadStatus(payload: {
  notifyItemId: number;
  isRead: boolean;
}): BaseTockAction {
  return {
    type: 'SET_NOTIFY_ITEM_READ_STATUS',
    payload: payload,
  };
}

export function setNewNotifyItems(payload: {
  notifyItems: GetHelpMenuDisplayItemsQuery;
}): BaseTockAction {
  return {
    type: 'SET_NEW_NOTIFY_ITEMS',
    payload: payload.notifyItems,
  };
}
